import React, { useState, useRef } from 'react';
import { Helmet } from 'react-helmet';

const Enquiry = () => {
    const [result, setResult] = useState(""); // To show success or error message
    const [showModal, setShowModal] = useState(false); // To toggle the modal visibility
    const formRef = useRef(null); // Create a reference to the form

    const onSubmit = async (event) => {
        event.preventDefault();
        setResult("Sending....");
        setShowModal(true);  // Show the modal while submitting
        const formData = new FormData(event.target);

        formData.append("access_key", "e99fa4c4-6a6c-4abe-9cf2-75a2336cfa37");

        try {
            const response = await fetch("https://api.web3forms.com/submit", {
                method: "POST",
                body: formData,
            });

            const data = await response.json();

            if (data.success) {
                setResult("Form Submitted Successfully!");
            } else {
                setResult(`Error: ${data.message}`);
            }
        } catch (error) {
            setResult("Something went wrong. Please try again.");
        }

        // Clear the form fields after submission
        if (formRef.current) {
            formRef.current.reset();  // This will clear all the input fields in the form
        }
    };

    const closeModal = () => {
        setShowModal(false);
        setResult(""); // Reset result
    };

    return (
        <div>
            <Helmet>
                <title>Contact: +91 8624029699 | AB Ghule Cabs | Pune to Mumbai Cabs | Affordable & Reliable</title>
                <meta name="description" content="Book reliable and affordable Pune to Mumbai cabs with AB Ghule Cabs. One-way, round-trip, airport transfers, and luxury options available. Call +91 8624029699." />
                <meta name="keywords" content="Pune to Mumbai Cab Service, Affordable Cabs Pune to Mumbai, AB Ghule Cabs, Luxury Cabs Pune to Mumbai, Pune to Mumbai cheapest cab, Pune Mumbai Taxi Service, Pune to Mumbai Airport Cabs, Pune to Mumbai Outstation Cabs, Pune to Mumbai Cab Booking Online, Pune Mumbai Express Taxi, Pune to Mumbai Private Cabs, Pune Mumbai One-Way Taxi, Pune to Mumbai Round Trip Cabs, Pune to Mumbai Airport cab, Pune Mumbai Cab, Pune to Mumbai Taxi, Pune to Mumbai Airport Cab Fare, Pune Mumbai Airport Drop, Pune to mumbai cheapest cab, Pune to Mumbai Cab Service, best cab service Pune to Mumbai, Pune to mumbai cab fare, Pune Mumbai taxi service, Pune to Mumbai car, Pune Mumbai taxi fare, Pune to Mumbai international airport cab, Pune to Mumbai cab price, Pune to Mumbai airport cab price, Pune to Mumbai taxi one way, Pune to Mumbai cab booking, Pune to Mumbai airport taxi, Pune Mumbai cab one way" />
                <meta name="robots" content="index, follow" />
                <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Pune to Mumbai Cabs | Affordable & Reliable" />
                <meta property="og:description" content="Book reliable and affordable Pune to Mumbai cabs with AB Ghule Cabs. One-way, round-trip, airport transfers, and luxury options available. Call +91 8624029699." />
                <meta property="og:image" content="https://abghulecabs.com/images/pune-to-mumbai-cabs.jpg" />
                <meta property="og:url" content="https://abghulecabs.com/pune-to-mumbai-cabs" />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="AB Ghule Cabs" />
            </Helmet>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>Enquiry</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="news-details-section fix section-padding">
                <div className="container">
                    <div className="row container">
                        <div className="col-8 offset-lg-2">
                            <div className="row">
                                <div className="de-item-list mb30">
                                    <h3 className="text-white">Do you have any enquiry?</h3>
                                    <form
                                        name="contactForm"
                                        id="contact_form"
                                        className="form-border"
                                        onSubmit={onSubmit}
                                        ref={formRef} // Add the ref to the form
                                    >
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <div className="form-group position-relative">
                                                    <label htmlFor="name" className="text-dark small textt">Your Full Name</label>
                                                    <input
                                                        name="name"
                                                        id="name"
                                                        className="form-control form-control-lg rounded-0"
                                                        placeholder="Your Full Name"
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <div className="form-group position-relative">
                                                    <label htmlFor="email" className="text-dark small textt">Your Email</label>
                                                    <input
                                                        type="email"
                                                        name="email"
                                                        id="email"
                                                        className="form-control form-control-lg rounded-0"
                                                        placeholder="Your Email"
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <div className="form-group position-relative">
                                                    <label htmlFor="phone" className="text-dark small textt">Your Phone</label>
                                                    <input
                                                        type="tel"
                                                        name="phone"
                                                        id="phone"
                                                        className="form-control form-control-lg rounded-0"
                                                        placeholder="Your Phone"
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <div className="form-group position-relative">
                                                    <label htmlFor="Cab_location" className="text-dark small textt">Cabs </label>
                                                    <input
                                                        name="Cab_location"
                                                        id="Cab_location"
                                                        className="form-control form-control-lg rounded-0"
                                                        placeholder="Cab Name"
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <div className="form-group position-relative">
                                                    <label htmlFor="days" className="text-dark small textt">Number of Days</label>
                                                    <input
                                                        name="days"
                                                        id="days"
                                                        className="form-control form-control-lg rounded-0"
                                                        placeholder="Number of Days"
                                                        required
                                                        type="number"
                                                        min="1"
                                                        max="100"
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <div className="form-group position-relative">
                                                    <label htmlFor="pick_up_point" className="text-dark small textt">Pick Up Point</label>
                                                    <input
                                                        name="pick_up_point"
                                                        id="pick_up_point"
                                                        className="form-control form-control-lg rounded-0"
                                                        placeholder="Pick Up Point"
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <div className="form-group position-relative">
                                                    <label htmlFor="Cab" className="text-dark small textt">Select Cabs</label>
                                                    <select
                                                        name="Cab"
                                                        id="Cab"
                                                        className="border py-2 form-control form-control-lg rounded-0"
                                                        required
                                                    >
                                                        <option value="" className='textt' disabled>Select Cabs</option>
                                                        <option value="Swift Dzire (4 + 1 Seater)">Swift Dzire (4 + 1 Seater)</option>
                                                        <option value="Kia Carens(6 + 1 Seater)">Kia Carens(6 + 1 Seater)</option>
                                                        <option value="Ertiga (6 + 1 Seater)">Ertiga (6 + 1 Seater)</option>
                                                        <option value="Tavera (6 + 1 Seater)">Tavera (6 + 1 Seater)</option>
                                                        <option value="Innova (6 + 1 Seater)">Innova (6 + 1 Seater)</option>
                                                        <option value="13 Seater(13 Seater)">13 Seater(13 Seater)</option>
                                                        <option value="17 Seater(17 Seater)">17 Seater(17 Seater)</option>
                                                        <option value="Innova Crysta(6 + 1 Seater)">Innova Crysta(6 + 1 Seater)</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <div className="form-group position-relative">
                                                    <label htmlFor="date" className="text-dark textt small">Date of Journey</label>
                                                    <input
                                                        type="date"
                                                        name="date"
                                                        id="date"
                                                        className="form-control form-control-lg rounded-0"
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-12 mb-3">
                                                <div className="form-group position-relative">
                                                    <label htmlFor="message" className="text-dark small textt">Message</label>
                                                    <textarea
                                                        name="message"
                                                        id="message"
                                                        rows="5"
                                                        className="form-control form-control-lg rounded-0"
                                                        placeholder="Your Message"
                                                        required
                                                    ></textarea>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="g-recaptcha" data-sitekey="your-recaptcha-site-key-here"></div>

                                        <div id="submit" className="mt20 text-center py-3 px-5">
                                            <button
                                                type="submit"
                                                className="btn-main mt-2 py-2 px-3 border-0 text-balck"
                                            >
                                                Submit Now
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Modal for success or error message */}
            {showModal && (
                <div className="modal show" style={{ display: 'block' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Submission Status</h5>
                                <button type="button" className="close" onClick={closeModal}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <p className={result.includes("Successfully") ? "text-success" : "text-danger"}>{result}</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={closeModal}>Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Enquiry;
